import classnames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Tooltip } from 'components/ui/base';

import * as styles from '../MediaGallery.module.less';

type DownloadProps = {
  disabled?: boolean;
  onDownload: () => void;
};

const Download: React.FC<DownloadProps> = ({ disabled, onDownload }) => {
  const handleDownload = React.useCallback(() => {
    if (!disabled) {
      onDownload();
    }
  }, [disabled, onDownload]);

  return (
    <Tooltip title={<FormattedMessage id="download" defaultMessage="Download" />}>
      <i
        data-cy="download"
        className={classnames(styles['media-actions__icon'], 'fb-icon--download', {
          [styles['icon-disabled']]: disabled
        })}
        onClick={handleDownload}
      />
    </Tooltip>
  );
};

export default Download;
